export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

// Optional<TypeWithNoOptionalFields, 'optional' | 'fields' | 'go' | 'here'>
export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;
